import { render, staticRenderFns } from "./CTABanner.vue?vue&type=template&id=5c016d08&scoped=true&"
import script from "./CTABanner.vue?vue&type=script&lang=js&"
export * from "./CTABanner.vue?vue&type=script&lang=js&"
import style0 from "./CTABanner.vue?vue&type=style&index=0&id=5c016d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c016d08",
  null
  
)

export default component.exports